export class ILabel {
  label?: string
  value?: any

  constructor(label: string, value: any) {
    this.label = label
    this.value = value
  }
}
